function clean(value: string | null | undefined): string {
  return value?.trim().slice(0, 120) || "";
}

export function fallbackElementLabel(input: { track?: string | null; aria?: string | null; text?: string | null; tag?: string | null }): string {
  return clean(input.track) || clean(input.aria) || clean(input.text) || clean(input.tag).toLowerCase() || "unknown element";
}

export function fallbackSectionLabel(input: { dataSection?: string | null; heading?: string | null; path?: string | null }): string {
  return clean(input.dataSection) || clean(input.heading) || clean(input.path) || "unknown section";
}
